import {ConnectedComponent, sharedComponent} from 'lowkey-component';

import {sleep} from '@lib/utils';
import {ScrollService} from '@services/ScrollService';
import {appSelectors} from '@store/appSlice';

@sharedComponent
export class Wrapper extends ConnectedComponent {
  private scroll = ScrollService.create();

  didMount() {
    this.observe(appSelectors.selectIsOpenGlobalNav, async (isOpen) => {
      if (isOpen) {
        await sleep(300);
        return this.scroll.stopScroll(this.element);
      } else {
        return this.scroll.startScroll();
      }
    });
    // this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
    //   if (status === 'show') {
    //     this.windowScrollY = 0
    //   }
    // })
  }
}
